const actionCreator = <T>(type: string | number, payload?: T) =>
  payload ? { type, payload } : { type };

export default actionCreator;
